module.exports = __webpack_public_path__ + "static/media/APODACA.3b1f4d8c.jpg";